<template>
  <section class="itinerary_description__container">
    <div
      v-if="!hideElementByCondition"
      class="mb-5 w-100 is-flex updateItineraryButton"
    ></div>
    <div class="card">
      <div class="card-content">
        <div v-if="info && info.itinerary">
          <div class="columns">
            <div class="column">
              <h5 class="title is-6">Included</h5>
              <SortableTextList
                v-model="form.included"
                :disabled="disableQuoteByStatus"
              />
            </div>
            <div class="column">
              <h5 class="title is-6">Not Included</h5>
              <SortableTextList
                v-model="form.notIncluded"
                :disabled="disableQuoteByStatus"
              />
            </div>
          </div>
        </div>
        <footer class="card-footer pr-0">
          <div class="card-footer-item is-justify-content-flex-end pb-0">
            <BaseButton
              size="medium"
              data-action-type="ITINERARY:DESCRIPTION_SAVE"
              action="tercery"
              :loading="isSaving"
              :disabled="disableQuoteByStatus"
              @click="saveEdit"
            >
              <i slot="icon" class="mr-4 ml-1">
                <IconCheck class="icon is-small" />
              </i>
              <p slot="text">Save</p>
            </BaseButton>
          </div>
        </footer>
      </div>
    </div>
  </section>
</template>

<script>
import { VueEditor } from "vue2-editor";
import helpers from "@/helpers";
import BookContent from "@/components/quote-views/book/BookContent.vue";
import { mapGetters } from "vuex";
import PhasesProgress from "@/components/_shared/PhasesProgress.vue";
import { helper } from "@/utils/itinerary";
import ItineraryTermCondition from "@/components/quote-views/itinerary/ItineraryTermCondition.vue";
import { openToast } from "@/utils/utils";
import IconCheck from "@/components/icons/IconCheck.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import SortableTextList from "@/components/quote-views/_shared/SortableTextList.vue";

export default {
  name: "InclusionView",
  components: {
    SortableTextList,
    VueEditor,
    BaseButton,
    IconCheck,
    ItineraryTermCondition,
    BookContent,
    PhasesProgress,
  },
  props: {
    loadItinerary: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      loadingText: "Loading content, please wait...",
      isSaving: false,
      helpers: {
        ...helper,
      },
      form: {
        included: [],
        notIncluded: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
      hideElementByCondition: "itinerary/getHideElementByCondition",
      formItinerary: "itinerary/getFormItinerary",
      disableQuoteByStatus: "itinerary/getDisableQuoteByStatus",
    }),
    backgroundImage() {
      return helpers.backgroundImage(
        "https://305c511294116d47a2eb-8984c8bf4382d773df005374b9639769.ssl.cf2.rackcdn.com/itereo/ttc/background_app.jpg"
      );
    },
    info() {
      return {
        itinerary: this.itinerary,
      };
    },
  },
  watch: {
    formItinerary(newForm) {
      this.form = {
        included: newForm[0].included,
        notIncluded: newForm[0].not_included,
      };
    },
  },
  activated() {
    if (this.$route.query.itinerary && !this.info.itinerary.data) {
      this.loadItineraryByRouteQuery();
    }

    this.form = {
      included: this.formItinerary[0].included,
      notIncluded: this.formItinerary[0].not_included,
    };
  },
  methods: {
    setLoading(value = false) {
      this.$store.dispatch("utils/setLoading", value);
      if (!value) {
        this.setLoadingText("Loading content, please wait...");
      }
    },
    setLoadingText(value) {
      this.$store.dispatch("utils/setLoadingText", value);
    },
    async loadItineraryByRouteQuery() {
      this.setLoading(true);
      await this.loadItinerary();
      this.setLoading(false);
    },
    updateLoading(value) {
      this.loading = value;
    },
    async saveEdit() {
      if (this.isSaving) {
        return false;
      }

      this.isLoading = true;
      this.isSaving = true;

      const formItinerary = {
        ...this.formItinerary[0],
        included: this.form.included,
        not_included: this.form.notIncluded,
      };

      await this.$store
        .dispatch("itinerary/update", {
          ...formItinerary,
          cur_step: 1,
          last_step: 1,
        })
        .then(() => {
          openToast(
            this.$buefy,
            "Inclusions saved successfully!",
            "is-success"
          );

          this.isLoading = false;
          this.isSaving = false;
          this.loadItinerary();
        })
        .catch((error) => {
          this.isLoading = false;
          this.isSaving = false;
          throw error;
        });
    },
  },
};
</script>

<style>
.card__booking__status {
  padding: 2rem;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0px 0 1px rgba(10, 10, 10, 0.02);
  border-radius: 0.75rem;
  background-color: #fff;
}
.card__booking__status h2 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
}
@media screen and (max-width: 480px) {
  .card__booking__status {
    padding: 1rem;
  }
}
</style>
